import { writable } from "svelte/store";
import { LayerListItemManager } from "./LayerListItemManager";
export class LayerListItemGroupManager {
    constructor(layersControlManager, groupKey, layers, oneGroup) {
        this.expandedStore = writable(true);
        this.layersControlManager = layersControlManager;
        this.modelTranslationKeyStore = layersControlManager.getModelTranslationKeyStore();
        this.layerListItemManagers = layers.map(l => {
            return new LayerListItemManager(l, this.modelTranslationKeyStore);
        });
        this.groupKey = groupKey;
        this.oneGroup = oneGroup;
    }
    getModelTranslationKeyStore() {
        return this.modelTranslationKeyStore;
    }
    getOneGroup() {
        return this.oneGroup;
    }
    getGroupKey() {
        return this.groupKey;
    }
    getLayerListItemManagers() {
        return this.layerListItemManagers;
    }
    getExpandedStore() {
        return this.expandedStore;
    }
}
